import apiApp from '@/api/modules/app'
import apiUser from '@/api/modules/user'
import router from '@/router'

export const useUserStore = defineStore(
  // 唯一ID
  'user',
  () => {
    const settingsStore = useSettingsStore()
    const routeStore = useRouteStore()
    const menuStore = useMenuStore()
    const tabbarStore = useTabbarStore()

    const account = ref(localStorage.account ?? '')
    const token = ref(localStorage.token ?? '')
    const avatar = ref(localStorage.avatar ?? '')
    const userName = ref('')
    const schoolName = ref(localStorage.school_name ?? '')
    const permissions = ref<string[]>([])
    const isLogin = computed(() => {
      if (token.value) {
        return true
      }
      return false
    })

    // 登录
    async function login(data: {
      account: string
      password: string
      captcha: string
      captcha_token: string
    }) {
      const res = await apiApp.login({
        user_code: data.account,
        password: data.password,
        captcha: data.captcha,
        captcha_token: data.captcha_token,
      })
      localStorage.setItem('account', data.account)
      localStorage.setItem('token', res.data.token)
      localStorage.setItem('school_id', res.data.user_info.school_id)
      localStorage.setItem('user_id', res.data.user_info.user_id)
      localStorage.setItem('school_name', res.data.user_info.school_name)
      localStorage.setItem('role', res.data.user_info.role)
      localStorage.setItem('need_change_pwd', res.data.user_info.change_pwd ? 'true' : 'false')
      localStorage.setItem('is_admin', res.data.user_info.is_admin)
      // localStorage.setItem('avatar', res.data.avatar)
      account.value = data.account
      token.value = res.data.token
      // avatar.value = res.data.avatar
    }

    // 手动登出（个人中心 path 固定为 /home/user_center，fullPath 会带 ?is_open= 等 query，需用 path 判断）
    function logout(redirect = router.currentRoute.value.fullPath) {
      // 此处仅清除计算属性 isLogin 中判断登录状态过期的变量，以保证在弹出登录窗口模式下页面展示依旧正常
      localStorage.removeItem('token')
      token.value = ''
      const route = router.currentRoute.value
      const shouldRecordRedirect
        = route.path !== '/home/user_center'
          && route.fullPath !== settingsStore.settings.home.fullPath
          && route.name !== 'login'
      router.push({
        name: 'login',
        query: shouldRecordRedirect ? { redirect } : {},
      }).then(logoutCleanStatus)
    }
    // 请求登出
    function requestLogout() {
      // 此处仅清除计算属性 isLogin 中判断登录状态过期的变量，以保证在弹出登录窗口模式下页面展示依旧正常
      localStorage.removeItem('token')
      token.value = ''
      const route = router.currentRoute.value
      const shouldRecordRedirect
        = route.path !== '/home/user_center'
          && route.fullPath !== settingsStore.settings.home.fullPath
          && route.name !== 'login'
      router.push({
        name: 'login',
        query: shouldRecordRedirect ? { redirect: route.fullPath } : {},
      }).then(logoutCleanStatus)
    }
    // 登出后清除状态
    function logoutCleanStatus() {
      localStorage.removeItem('account')
      localStorage.removeItem('avatar')
      localStorage.removeItem('need_change_pwd')
      account.value = ''
      avatar.value = ''
      permissions.value = []
      settingsStore.updateSettings({}, true)
      tabbarStore.clean()
      routeStore.removeRoutes()
      menuStore.setActived(0)
    }

    // 获取权限
    async function getPermissions() {
      const res = await apiUser.get_authority_code_list()
      permissions.value = res.data
    }
    // 修改密码
    async function editPassword(data: {
      password: string
      newPassword: string
    }) {
      await apiUser.change_password({
        old_password: data.password,
        new_password: data.newPassword,
        confirm_password: data.newPassword,
      })
    }

    // 获取用户信息
    async function getUserInfo() {
      const res: any = await apiUser.get_my_user_info()
      if (res.code === 1 && res.data) {
        userName.value = res.data.user_name
        avatar.value = res.data.avatar
      }
    }

    return {
      account,
      token,
      avatar,
      userName,
      schoolName,
      permissions,
      isLogin,
      login,
      logout,
      requestLogout,
      getPermissions,
      getUserInfo,
      editPassword,
    }
  },
)
